module.exports = __webpack_public_path__ + "img/arrow-down-ccc.e1816ed7.svg";